import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LayoutModule } from '../layout/layout.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NguCarouselModule } from '@ngu/carousel';
import { NgxPaginationModule } from 'ngx-pagination';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleDriveProvider } from '../services/GoogleDriveProvider';
import { TemplateEightComponent } from './template-eight/template-eight.component';
import { TemplateOneComponent } from './template-one/template-one.component';
import { TemplateTwoComponent } from './template-two/template-two.component';
import { TemplateThreeComponent } from './template-three/template-three.component';
import { TemplateFourComponent } from './template-four/template-four.component';
import { TemplateFiveComponent } from './template-five/template-five.component';
import { TemplateSixComponent } from './template-six/template-six.component';
import { TemplateSevenComponent } from './template-seven/template-seven.component';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap';
@NgModule({
  declarations: [
    TemplateEightComponent,
    TemplateOneComponent,
    TemplateTwoComponent,
    TemplateThreeComponent,
    TemplateFourComponent,
    TemplateFiveComponent,
    TemplateSixComponent,
    TemplateSevenComponent
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    LayoutModule,
    NgbModule,
    NgxPaginationModule,
    NguCarouselModule,
    TranslateModule,
    ReactiveFormsModule,
    RouterModule,
    ModalModule.forRoot(),
  ],
  exports:[
    TemplateEightComponent,
    TemplateOneComponent,
    TemplateTwoComponent,
    TemplateThreeComponent,
    TemplateFourComponent,
    TemplateFiveComponent,
    TemplateSixComponent,
    TemplateSevenComponent
  ],
  providers:[GoogleDriveProvider]
})
export class TemplatesModule { }
